<template>
  <div
    class="grouped-line-chart mt-3"
    :style="{width: width + 'px'}"
  >
    <div class="row">
      <div
        v-for="(key, index) in itemGroups"
        :key="key"
        :class="`col-${12/widthDivider} line-chart-wrapper`"
      >
        <h2 class="text-black mb-4 mt-3">
          {{ items &&items[index] ? items[index].name : '' }}
        </h2>

        <multi-line-chart
          :items="items &&items[index]? items[index].val : null"
          :legend-items="legend.items"
          :width="clientWidth <= 1440 ? width : width/widthDivider"
          :height="height"
          :min-width="clientWidth <= 1440 ? minWidth : minWidth - 100"
          :timeframe="timeframe"
          :timeframe-labels="timeframeLabels"
          :show-label="false"
          :data-type="key"
          :analytics-type="type"
        />
      </div>

      <div
        v-if="legend.items && items"
        class="legend-wrapper"
      >
        <category-legend
          :items="legend.items"
          :items-active="items[0].val"
          :client-width="clientWidth"
          :show-na="showNa(itemGroups, timeframe)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {capitalise} from '@/analytics/utils/data-analyser-utils'

import MultiLineChart from '@/components/d3/MultiLineChart'
import CategoryLegend from '@/components/d3/CategoryLegend'

import LineChartMixin from '@/analytics/mixins/LineChartMixin'

const props = {
  timeframeLabels: {
    type: Array,
  },
  items: {
    type: Array,
  },
  itemGroups: {
    type: Array,
    required: true,
  },
  margin: {
    type: Object,
    default: () => ({
      left: 70,
      right: 10,
      top: 10,
      bottom: 70,
    }),
  },
  width: {
    type: Number,
    default: 1100,
  },
  clientWidth: {
    type: Number,
    required: true,
  },
  minWidth: {
    type: Number,
    default: null,
  },
  height: {
    type: Number,
    default: 300,
  },
  timeframe: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
}

export default {
  name: 'LineChart',
  mixins: [LineChartMixin],
  components: {
    MultiLineChart,
    CategoryLegend,
  },
  props: props,
  data () {
    return {
      legend: {
        items: {
          [this.type]: {name: 'This ' + this.capitalise(this.type), color: '#0e094d'},
          channel: {name: 'Channel Average', color: '#0364f6'},
          network: {name: 'Network Average', color: '#62ddc7'},
          [this.type + 'Na']: {color: '#8684a6'},
          channelNa: {color: '#81b1fa'},
          networkNa: {color: '#b0eee3'},
        },
      },
    }
  },
  computed: {
    widthDivider () {
      return this.itemGroups.length > 1 ? 2 : 1
    },
  },
  methods: {
    capitalise (str) {
      return capitalise(str)
    },
  },
}
</script>

<style lang="scss">
  .grouped-line-chart {
    padding: 8px 24px 16px 24px;
    border: 1px solid #dfe2ee;
    border-radius: 2px;
    display: inline-block;
    overflow: hidden;
    row {
      margin-right: 0;
    }
    h2 {
      margin: 0 0 12px 36px;
      color: #000000;
      font-size: 16px;
    }
    .line-chart-wrapper {
      padding: 0;
    }
    .legend-wrapper {
      margin: 8px 0 0 24px;
    }

    @media (max-width: 1440px) {
      .line-chart-wrapper {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }

  }
</style>
